import React, { useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import assets from '../assets';

function ProjectSection() {
  const projectData = {
    websites: [
      {
        id: 'Price Book',
        image: assets.PriceBook,
        title: 'Price Book',
        description:
          'Homeowner Pricebook is a comprehensive platform designed to help homeowners easily estimate service costs and connect with professionals. Built with a user-friendly interface, the website streamlines the process of finding accurate pricing for home maintenance and repair services. Developed with a focus on performance and usability, it ensures a seamless experience for users',
        liveSite: 'https://homeowner.pricebookus.com/',
        techStack: ['Next.js', 'Material UI', 'TypeScript', 'Redux'],
      },
      {
        id: 'Stampa Solutions',
        image: assets.Stampa,
        title: 'Stampa Solutions',
        description:
          'Stampa Solutions is a leading provider of on-demand software development, offering expertise in AI, automation, cloud computing, and web & mobile development. With highly skilled developers across 70+ technologies, the platform helps businesses scale efficiently. The website highlights flexible collaboration models, success stories, and industry expertise, making it a go-to tech',
        liveSite: 'https://stampasolutions.com/',
        techStack: ['Next.js', 'Redux', 'Material UI', 'JavaScript'],
      },
      {
        id: 'VeriScan',
        image: assets.Veriscan,
        title: 'VeriScan',
        description:
          'Verscan is a comprehensive admin portal and mobile application designed to ensure product authenticity through QR code and NFC tag verification. We developed both the mobile app and website, empowering users with instant product verification, a trusted brand database, and a seamless user experience. With cutting-edge scanning technology and a secure verification process, Verscan redefines safe and confident shopping in the digital age.',
        liveSite: 'https://vapeverification-admin-dev.falconweb.app/auth/login',
        techStack: ['React.js', 'Material', 'Redux', 'TypeScript'],
      },
      {
        id: 'Grill Master',
        image: assets.GrillMaster,
        title: 'Grill Master',
        description:
          'Grill Masters is a rapidly growing fast-food chain known for its diverse menu featuring burgers, sandwiches, wraps, pizzas, and desserts. We developed a dynamic website that showcases their menu, store locations, and franchise opportunities, offering a seamless user experience. With a modern design and intuitive navigation, the platform enhances customer engagement while supporting the brand’s expansion efforts',
        liveSite: 'https://grillmasters.in/',
        techStack: ['Next.js', 'Tailwind CSS', 'Redux', 'JavaScript'],
      },
      {
        id: 'Nutrition Coach',
        image: assets.NutritionCoach,
        title: 'Nutrition Coach',
        description:
          'Nutrition Coach is a dedicated platform designed for a professional nutrition coach to educate and guide people on healthy eating habits. The website provides expert advice on nutrition, meal planning, and dietary recommendations while also offering access to online food options. Built with a clean and user-friendly interface, it ensures an engaging experience for users seeking a healthier lifestyle',
        liveSite: 'https://nutritioncoach.com.pk/',
        techStack: ['React.js', 'Redux', 'Material UI'],
      },
    ],
    mobileApps: [
      {
        id: 'VeriScan',
        image: assets.VeriscanA,
        title: 'VeriScan',
        description:
          'Veriscan is a cross-platform product verification app we built to help consumers ensure authenticity with a simple scan. Designed for modern shoppers, it provides a fast and reliable way to detect counterfeit goods, giving users confidence in their purchases. Whether on iOS or Android, Veriscan empowers buyers with instant verification, redefining trust in the marketplace',
        liveSite:
          'https://play.google.com/store/apps/details?id=com.veriscan&hl=en_US&gl=US',
        techStack: [
          'React Native',
          'Redux ToolKit',
          'Vision Camera',
          'NFC Code Scanner',
          'TypeScript',
        ],
      },
      {
        id: 'Freelance Now',
        image: assets.FreelanceNowA,
        title: 'Freelance Now',
        description:
          'FreelanceNow is a cross-platform job-matching app designed for instant hiring. It connects businesses with available freelancers through real-time job postings, ensuring fast and efficient recruitment. With built-in anonymity and a focus on immediate opportunities, FreelanceNow eliminates unnecessary calls and streamlines the hiring process for both recruiters and freelancers',
        liveSite:
          'https://play.google.com/store/apps/details?id=com.freelanceNow',
        techStack: [
          'React Native',
          'Redux ToolKit',
          'Chat Sockets',
          'Push Notifications',
          'TypeScript',
        ],
      },
      {
        id: 'QR Tag.it',
        image: assets.QRTagitA,
        title: 'QR Tag.it',
        description:
          'QRTag.it is a cross-platform lost-and-found solution we developed for our client, allowing users to tag and register their valuable items. If an item is misplaced, its unique QRTag can be scanned to instantly notify the owner. The platform connects both parties through a web and mobile app, ensuring a seamless and efficient recovery process',
        liveSite:
          'https://play.google.com/store/apps/details?id=com.withered_feather_36062',
        techStack: [
          'React Native',
          'Redux',
          'Push Notification',
          'QR Code Reader',
          'Firebase',
          'Chat Sockets',
          'TypeScript',
        ],
      },
      {
        id: 'Pick Me',
        image: assets.PickMeA,
        title: 'Pick Me',
        description:
          'PickMe is a cross-platform gifting app that lets users create personalized profiles with preferences, sizes, and interests. By adding friends and family, users can easily share gift ideas from popular third-party sites like Amazon and Shopify. Available on both iOS and Android, PickMe eliminates the guesswork, ensuring perfect gifts every time 🎁',
        liveSite:
          'https://play.google.com/store/apps/details?id=com.pick_me_30127',
        techStack: ['React Native', 'TypeScript', 'Redux'],
      },
    ],
  };

  const [activeTab, setActiveTab] = useState('websites');

  const [selectedProject, setSelectedProject] = useState(
    projectData.websites[0]
  );

  useEffect(() => {
    setSelectedProject(projectData[activeTab][0]);
  }, [activeTab]);

  const handleTabClick = (e, tab) => {
    e.preventDefault();
    setActiveTab(tab);
  };

  const handleLinkClick = (e, project) => {
    e.preventDefault();
    setSelectedProject(project);
  };

  return (
    <Fade>
      <div className="project-main">
        <div className="project-inner">
          <Fade top>
            <div className="project-text-h">
              <h2>Making Ideas Come to Life!</h2>
              <p>
                Year after year, I work on exciting and life-changing projects
                which enable me to continue learning and stay updated on new
                technologies.
              </p>
            </div>
          </Fade>
          <Fade left>
            <div className="Links-project">
              <ul>
                <a
                  href="javascript:void(0)"
                  className={activeTab === 'websites' ? 'active-tab' : ''}
                  onClick={(e) => handleTabClick(e, 'websites')}
                >
                  Websites
                </a>
                <a
                  href="javascript:void(0)"
                  className={activeTab === 'mobileApps' ? 'active-tab' : ''}
                  onClick={(e) => handleTabClick(e, 'mobileApps')}
                >
                  Mobile Apps
                </a>
              </ul>
            </div>
          </Fade>
          <Fade right>
            <div className="main-category">
              <ul>
                {activeTab === 'websites'
                  ? projectData.websites.map((website) => (
                      <a
                        key={website.id}
                        href="javascript:void(0)"
                        className={
                          selectedProject.title === website.title
                            ? 'active-sub'
                            : ''
                        }
                        onClick={(e) => handleLinkClick(e, website)}
                      >
                        {website.title}
                      </a>
                    ))
                  : projectData.mobileApps.map((mobileApp) => (
                      <a
                        key={mobileApp.id}
                        href="javascript:void(0)"
                        className={
                          selectedProject.title === mobileApp.title
                            ? 'active-sub'
                            : ''
                        }
                        onClick={(e) => handleLinkClick(e, mobileApp)}
                      >
                        {mobileApp.title}
                      </a>
                    ))}
              </ul>
            </div>
          </Fade>
          <Zoom>
            <div className="chnage-project-section">
              <div
                className="chng-image-div"
                style={{
                  flex: '0 0 45%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    borderRadius: '10px',
                  }}
                />
              </div>
              <div
                className="Chang-roject-text"
                style={{
                  flex: '0 0 50%',
                  paddingLeft: '20px',
                  textAlign: 'left',
                }}
              >
                <a
                  href={selectedProject.liveSite}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visit Project
                </a>
                <h2>{selectedProject.title}</h2>
                <p>{selectedProject.description}</p>
                <div className="project-span">
                  {selectedProject.techStack.map((tech, index) => (
                    <span key={index} className={`span-${index + 1}`}>
                      {tech} {'  '}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Zoom>
        </div>
      </div>
    </Fade>
  );
}

export default ProjectSection;
